import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LoginComponent } from './login/login.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ActivateaccountComponent } from './login/activateaccount/activateaccount.component';
import { AgentaccessComponent } from './login/agentaccess/agentaccess.component';
import { SignupComponent } from './signup/signup.component';
import { NotificationsComponent } from './main/notifications/notifications.component';
import { SmsverificationComponent } from './signup/smsverification/smsverification.component';
import { SmsaddcodeComponent } from './signup/smsaddcode/smsaddcode.component';
import { AccountconfirmedComponent } from './signup/accountconfirmed/accountconfirmed.component';
import { MailComponent } from './signup/mail/mail.component';
import { RegisterComponent } from './register/register.component';

const areasRoutes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'activateaccount/:ta',
        component: ActivateaccountComponent,
      },
    ],
  },
  {
    path: 'login/:language',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'activateaccount/:ta',
        component: ActivateaccountComponent,
      },
    ],
  },
  {
    path: 'login/:language/:changetheme',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'activateaccount/:ta',
        component: ActivateaccountComponent,
      },
    ],
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
  },
  {
    path: 'resetPassword',
    component: ResetPasswordComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'agentaccess',
    component: AgentaccessComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
    children: [
      {
        path: '',
        component: MailComponent,
      },
      {
        path: 'smsverification',
        component: SmsverificationComponent,
      },
      {
        path: 'smsaddcode',
        component: SmsaddcodeComponent,
      },
      {
        path: 'accountconfirmed',
        component: AccountconfirmedComponent,
      },
    ],
  },
  {
    path: 'signup/:language',
    component: SignupComponent,
    children: [
      {
        path: '',
        component: MailComponent,
      },
      {
        path: 'smsverification',
        component: SmsverificationComponent,
      },
      {
        path: 'smsaddcode',
        component: SmsaddcodeComponent,
      },
      {
        path: 'accountconfirmed',
        component: AccountconfirmedComponent,
      },
    ],
  },
  {
    path: 'login',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login/:language',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'publicplanner',
    loadChildren: () =>
      import('./publicplanner/publicplanner.module').then(
        (m) => m.PublicplannerModule
      ),
  },
  {
    path: 'Onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(areasRoutes)],
  exports: [RouterModule],
})
export class AreasRoutingModule {}
